import { Grid, Typography } from "@mui/material";
import { StatusIconsSwitch } from "../StatusIconsSwitch.component";

export default function CustomItemStatusTypography({ title, status }) {
  return (
    <Grid item xs={3} sx={{ display: { md: "flex" } }}>
      <Typography display="flex" alignItems="center" variant="body2">
        {title}
        <StatusIconsSwitch status={status} />
      </Typography>
    </Grid>
  );
}
